import { useModals } from "react-easy-modals";
import CategoriesNavigationModal from "@/components/categories-navigation-modal";
import BaseApp from "@/modules/base-app";
import useListenToTargetClick from "@/modules/hooks/use-listen-to-target-click";

function CategoriesNavigation({ selector, ...props }) {
  const modals = useModals();

  const handleClick = (e: MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    const element = e?.currentTarget as HTMLElement;
    const clickedCategoryId = element?.dataset?.category_id || element?.dataset?.categoryId;
    const urlParamsString = element?.dataset?.url_params || element?.dataset?.urlParams;

    const categoryIdToUse = clickedCategoryId ? Number(clickedCategoryId) : props.category_id;
    let urlParams = props.url_params;

    if (urlParamsString) {
      try {
        urlParams = JSON.parse(urlParamsString);
      } catch (error) {
        console.error("Failed to parse url_params:", error);
      }
    }

    modals.open(CategoriesNavigationModal, {
      ...props,
      category_id: categoryIdToUse,
      url_params: urlParams,
    });
  };

  useListenToTargetClick(selector, handleClick);

  return null;
}

const CategoriesNavigationModalApp = (props) => (
  <BaseApp>
    <CategoriesNavigation {...props} />
  </BaseApp>
);

export default CategoriesNavigationModalApp;
